import { Button, Form, Input, InputRef, Layout, message, Modal, Popover, Select, Space, Table, TablePaginationConfig, Upload } from "antd";
import { Content } from "antd/lib/layout/layout";
import Sider from "antd/lib/layout/Sider";
import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./SupplierListProductScreen.module.css";
import { useHistory, useLocation, useRouteMatch } from "react-router";
import useLoading from "../../hooks/useLoading";
import { useUserContext } from "../../Context/UserContext";
import { CheckAutoReport } from "../../Services/AppSettingService";
import { GetAllDynamic } from "../../Services/DynamicService";
import { CheckRolePermission } from "../../Services/AuthorizedService";
import { GetTemplateeBindFormNameDDL } from "../../Services/TemplateService";
import {
  DeleteReport,
  ReportTemplateSelectByReportID,
} from "../../Services/ReportService";
import { FilterOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { confirmDialog } from "primereact/confirmdialog";
import { SplitButton } from "primereact/splitbutton";
import DynamicTableRedCross from "../../components/RedcrossComponents/DynamicTableRedCross";
import { Editor } from "@tinymce/tinymce-react";
import { PlusOutlined } from '@ant-design/icons';
import type { RcFile, UploadProps } from 'antd/es/upload';
import type { UploadFile } from 'antd/es/upload/interface';
import { ISupplierProductModel } from "../../IRequestModel/ECatalog/ISupplierProductModel";
import { InsertSupplierProduct, GetSupplierProduct, UploadImage, GetSupplierProductImage, UpdateSupplierProduct, ImportProduct, RemoveImage } from "../../Services/e-pro/SupplierECatalogService";
import { SupplierProductData } from "../../Services/e-pro/models/SupplierProductModel";
import { CreateMemorandum, GetAllMasterCategotryGroup, GetSellerById, GetWolfTemplate } from "../../Services/e-pro/EcatalogService";
import useAuthRedcross from "../../hooks/useAuthRedcross";
import { exportExcel } from "../../Helper/ExportExcel";
import Swal from "sweetalert2";
import AuthRedcrossContext from "../../Context/AuthRedcrossContext";
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import type { UploadChangeParam } from 'antd/es/upload';
import { getSellerByEmpCode } from "../../Services/e-pro/SupplierService";

const SupplierListProductScreen = () => {
    const location = useLocation();
    const apiName = "DynamicReport".replace("/", "");
    //const [text, setText] = useState<string>("");
    const [itemsCount, setItemsCount] = useState<number>(0);
    const [supplierList, setSupplierList] = useState<SupplierProductData[]>();
    const [tableData, setTableData] = useState<any[]>([]);
    const [supplierColumns, setSupplierColumns] = useState<any[]>();
    const [visibleDialog, setVisibleDialog] = useState<boolean>(false);
    const [template, setTemplate] = useState<any>([]);
    const { isLoad, setLoad } = useLoading();

    const [userData] = useUserContext();
    const [emp_data, setEmp_data] = useState<any>();
    const [_baseUrl, setbaseUrl] = useState<string>();
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const { search } = useLocation();
    const query = useMemo(() => new URLSearchParams(search), [search]);
    const [isAutoReport, setIsAutoReport] = useState<boolean>(false);
    const [canEdit, setCanEdit] = useState<boolean>(false);
    const { url } = useRouteMatch();
    const [selectedRows, setSelectedRows] = useState<number[]>([]);

    const [form] = Form.useForm();
    const [itemOnModal, setItemOnModal] = useState<ISupplierProductModel>();

    const [openModal, setOpenModal] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [contentEditor, setContentEditor] = useState();
    const [categoryItem, setCategoryItem] = useState<any>([]);

    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [fileListRemove, setFileListRemove] = useState<UploadFile[]>([]);
    const [exportLoading, setExportLoading] = useState<boolean>(false);
    const [tableLoading, setTableLoading] = useState<boolean>(false);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [sellerInfo, setSellerInfo] = useState<any>();
    const searchInput = useRef<InputRef>(null);
    const inputFile = useRef(null) 
    let history = useHistory();

    type DataIndex = keyof SupplierProductData;
    const { TextArea } = Input;
    const [paginationOption, setPaginationOption] =
      useState<TablePaginationConfig>({
        position: ["bottomLeft"],
        size: "small",
        current: 1,
        showSizeChanger: true,
        onChange: (page, pageSize) => {
          let _page: TablePaginationConfig = paginationOption;
          _page.current = page;
          _page.pageSize = pageSize;
  
          setPaginationOption(_page);
        },
      });

          useEffect(() => {
            getSellerInfo();
           
          
          }, []);
      
          useEffect(() => {
            getProductCategory();

          }, [sellerInfo]);
      
          async function getSellerInfo(){
            
            let response = await getSellerByEmpCode(userData.EmployeeCode);
            const data = response.data;
      
            setSellerInfo(data);
          }
  
    useEffect(() => {
      if (!isAdmin) {
        if (tableData) {
          const findedData = tableData.find((e: any) => {
            if (
              e.CreatedBy === userData.NameEn ||
              e.CreatedBy === userData.NameTh
            ) {
              return e;
            }
          });
          if (findedData) {
            setCanEdit(true);
          }
        }
      }
    }, [tableData]);

    const transformKeys = (data: any[], keyMap: { [name: string]: string }) => {
      return data.map((item) => {
        let newItem: { [key: string]: any } = {};
        
        //newItem["RowID"] = item["RowID"];  
        Object.keys(keyMap).forEach((key) => {
            const newKey = keyMap[key] || key;
            newItem[newKey] = item[key];  
        });


        // Object.keys(item).forEach((key) => {
        //   if (keyMap[key] != undefined)
        //   {
        //     const newKey = keyMap[key] || key;
        //     newItem[newKey] = item[key];    
        //   }else if (key === "RowID"){
        //     newItem[key] = item[key];    
        //   }
        // });
        return newItem;
      });
    };
    async function fetchReport(categoryData:any) {
      try {
        setTableLoading(true);

        let _dataDynamic = await GetSupplierProduct({
          CreatedBy: userData.EmployeeId.toString()
        });

        let tempData = _dataDynamic.data;

        tempData = tempData.filter(x => x.EditMode !== "EDIT");
        setSupplierList(tempData);
  
        let mapValueToKey: { [name: string]: string } = {
          ItemID: "รหัส",
          //Image: "รูปสินค้า",
          ItemName: "ชื่อสินค้า",
          //CatagolyGroupItemID: "หมวดหมู่",
          CatagolyGroupItemName: "หมวดหมู่",
          // Brand: "ยี่ห้อ",
          // Model: "รุ่น",
          // Size: "ขนาด",
          // Color: "สี",
          ItemDescription: "รายละเอียดสินค้า",
          ItemPropertise: "คุณสมบัติเฉพาะ",
          Manufacturer: "ผู้ผลิต",
          ItemPrice: "ราคา", 
          Quantity: "จำนวน",
          ItemUnit: "หน่วยนับ",
          Contract: "เลขที่สัญญา"
        };
  
        if (tempData !== undefined && tempData !== null)
        {
          const transformedData = transformKeys(tempData, mapValueToKey);

          setTableData([...transformedData]);
        }
          //setIsAdmin(_isAdmin);
       
        //setSupplierColumns(undefined);
        //setText("Report List");

        

        setLoad(false);
      } catch (error) {
        console.log("report=>error", error);
        setLoad(false);
      }
      setTableLoading(false);
    }

    async function getProductCategory() {
      const response = await GetAllMasterCategotryGroup();
      const data = response.data;
      if (data != undefined){
        let selectItem = [];
        data.map((item) => {
          selectItem.push(
            {
              value: item.rowID,
              label: item.Text,
            }
          )
         
        });
        setCategoryItem(selectItem);
        fetchReport(selectItem);
      }
      
      //console.log(data); 
    }
  
    const actionBodyTemplate = (record: any) => {
      const adminActionBody = []
      if (record.SendToProcess === undefined || record.SendToProcess === false){
        adminActionBody.push(
          {
            label: "Edit",
            icon: "pi pi-pencil",
            command: async () => {
              console.log(record);
              setItemOnModal(undefined);
              setContentEditor((prevState: any) => ({
                ...prevState,
                value: "",
              }));
              setFileList([]);
              setFileListRemove([]);
  
              let filterItem = supplierList?.filter(x => x.RowID === record.RowID)[0];
              setItemOnModal(filterItem);
              
              setContentEditor((prevState: any) => ({
                ...prevState,
                value: filterItem?.ItemPropertise != null ? filterItem?.ItemPropertise : "",
              }));
              let tempImage = await GetSupplierProductImage({ ItemRowId: record.RowID});
              var tempUploadFile : UploadFile[] = [];
              
              tempImage.data?.map((img) => {
                tempUploadFile.push({
                  uid : img.Guid,
                  name: img.ItemPicName,
                  status: 'done',
                  url: img.ItemPicPath
                });
              })
              setFileList(tempUploadFile)
  
  
              setOpenModal(true);
            },
          },
        )
      }
      else {
        adminActionBody.push(
          {
            label: "View",
            icon: "pi pi-eye",
            command: async () => {
              console.log(record);
              setItemOnModal(undefined);
              setContentEditor((prevState: any) => ({
                ...prevState,
                value: "",
              }));
              setFileList([]);
              setFileListRemove([]);
  
              let filterItem = supplierList?.filter(x => x.RowID === record.RowID)[0];
              setItemOnModal(filterItem);
              
              setContentEditor((prevState: any) => ({
                ...prevState,
                value: filterItem?.ItemPropertise != null ? filterItem?.ItemPropertise : "",
              }));
              let tempImage = await GetSupplierProductImage({ ItemRowId: record.RowID});
              var tempUploadFile : UploadFile[] = [];
              
              tempImage.data?.map((img) => {
                tempUploadFile.push({
                  uid : img.Guid,
                  name: img.ItemPicName,
                  status: 'done',
                  url: img.ItemPicPath
                });
              })
              setFileList(tempUploadFile)
  
  
              setOpenModal(true);
            },
          },
        )
      }

      // const adminActionBody = [
      
      //   // {
      //   //   label: "Delete",
      //   //   icon: "pi pi-trash",
      //   //   command: () => {
      //   //     confirmDialog({
      //   //       message: "Do you want to delete this report.",
      //   //       header: "Delete",
      //   //       icon: "p-confirm-dialog-icon pi pi-info-circle",
      //   //       rejectClassName: "hide",
      //   //       acceptClassName:
      //   //         "p-button p-component p-confirm-dialog-accept table-accept p-button-danger table-control-confirm-button p-button-accept-cancel",
      //   //       accept: async () => {
      //   //         const res = await DeleteReport(record.ReportTemplateId);
      //   //         if (res) {
      //   //           setLoad(true);
      //   //           fetchReport();
      //   //         }
      //   //       },
      //   //     });
      //   //   },
      //   // },
      // ];
     
      // if (
      //   record.SendToProcess === undefined || record.SendToProcess === false
      // ) {
        return (
          <React.Fragment>
          <SplitButton
            className="p-button-secondary"
            model={adminActionBody}
            dropdownIcon="pi pi-ellipsis-v"
          />
        </React.Fragment>
        );
      //}
    };

    const uploadButton = (
      <div>
        <PlusOutlined rev={undefined} />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
    const handleChange: UploadProps['onChange'] = ({file, fileList: newFileList }) => {
      setFileList(newFileList);
    }
    const handleEditorChange = (content: any, editor: any) => {
      setContentEditor((prevState: any) => ({
        ...prevState,
        value: content,
      }));
    };

    useEffect(() => { 
      form.resetFields();
      if (itemOnModal != undefined){
        form.setFieldsValue({
          RowID: itemOnModal.RowID,
          ItemID : itemOnModal.ItemID,
          CatagolyGroupItemID : itemOnModal.CatagolyGroupItemID,
          Contract : itemOnModal.Contract,
          SellerID : itemOnModal.SellerID,
          ItemName : itemOnModal.ItemName,
          ItemDescription : itemOnModal.ItemDescription,
          ItemPropertise : itemOnModal.ItemPropertise,
          ItemUnit : itemOnModal.ItemUnit,
          IsActive : itemOnModal.IsActive,
          IsApprove : itemOnModal.IsApprove,
          Comment : itemOnModal.Comment,
          Brand : itemOnModal.Brand,
          Model : itemOnModal.Model,
          Size : itemOnModal.Size,
          Color : itemOnModal.Color,
          Manufacturer : itemOnModal.Manufacturer,
          ItemPrice : itemOnModal.ItemPrice,
          Quantity : itemOnModal.Quantity,
          CreatedBy : itemOnModal.CreatedBy,
          ModifiedBy : itemOnModal.ModifiedBy,
          EditMode : itemOnModal.EditMode,
          SendToProcess : itemOnModal.SendToProcess
    });
      }
      

    }, [itemOnModal]);

    const handleSaveModal = async (values) => {

      setConfirmLoading(true);

      values.SellerID = sellerInfo.SellerID;//userData.EmployeeId;
      values.CreatedBy = userData.EmployeeId.toString();
      values.ModifiedBy = userData.EmployeeId.toString();
      values.ItemPropertise = contentEditor?.value;
      values.IsActive = true;
      values.EditMode = "NEW";
      values.SendToProcess = false;
      let returnData = undefined;
      if (values.RowID == undefined || values.RowID === 0)
      {
        returnData = await InsertSupplierProduct(values);
      }else{
        returnData = await UpdateSupplierProduct(values);
      }
     
      console.log('valie modal:', values);

      if (returnData.data != undefined && returnData.data.RowID !== 0) {
        let temp1 = await UploadImage(
          fileList,
          returnData.data.RowID,
          userData.EmployeeId.toString(),
          userData.EmployeeId.toString()
        );
        if (fileListRemove.length > 0){

          let removeItem = fileListRemove.filter(x => x.originFileObj === undefined)?.map(a => a.uid);
          if (removeItem.length > 0)
            await RemoveImage(removeItem);
        }
      
      }

      form.resetFields();
      setConfirmLoading(false);
      fetchReport(categoryItem);
      setOpenModal(false)
    }

    async function PrcessObjectJson(itemImage){
      //setIsCardLoading(true);
      
      try{
          //setLoadingsSendOrder(true);
          var templateForm = await GetWolfTemplate("E-Catalog");
          console.log(templateForm);
          if (templateForm != null)
          {

            //let sellerInfo = await GetSellerById(userData.EmployeeId);
            let sellerInfo = await getSellerByEmpCode(userData.EmployeeCode);

            templateForm.form.map((_template) => {
              let setValue = null;
              switch (_template.template.label) {
                  case "ชื่อผู้ค้า":
                      setValue = sellerInfo.data.SellerName;
                      break;
                  case "ประเภทกิจการ":
                      setValue = sellerInfo.data.BussniesType != undefined ? sellerInfo.data.BussniesType : "";
                      break;
                  
                  case "เลขประจำตัวผู้เสียภาษี":
                      setValue = sellerInfo.data.TaxpayerIdentificationNo != undefined ? sellerInfo.data.TaxpayerIdentificationNo : "";
                      break;
                  case "วันที่ลงทะเบียน":
                      setValue = sellerInfo.data.DateOfRegisteration != undefined ? sellerInfo.data.DateOfRegisteration?.toString() : "";
                      break;
                  case "หมายเลขโทรศัพท์":
                      setValue = sellerInfo.data.PhoneNumber != undefined ? sellerInfo.data.PhoneNumber : "";
                      break;
                  case "e-mail":
                      setValue = userData.Email;
                      break;
                    case "รายละเอียดข้อมูลสินค้า":
                        //     // set data as table to row array
                     let rowItem = [];
                     let filterItem = supplierList.filter(x => x.SendToProcess !== true);//?.filter(item => item.checkItem);//.reduce((sum, current) => sum + (current.price * current.quantity), 0)
                     filterItem?.map((item) => {

                         let itemDesc = `ยี่ห้อ: ${item.Brand !== undefined && item.Brand !== "" ? item.Brand : "-"},`
                         itemDesc += `ชื่อรุ่น: ${item.Model !== undefined && item.Model !== "" ? item.Model : "-"},` 
                         itemDesc += `ขนาด: ${item.Size !== undefined && item.Size !== "" ? item.Size : "-"},`
                         itemDesc += `สี: ${item.Color !== undefined && item.Color !== "" ? item.Color : "-"}`; 

                         let subRowItem = [];
                         subRowItem.push({ "value": item.ItemID}); //"รหัสสินค้า"
                         subRowItem.push({ "value": item.ItemName}); //"ชื่อสินค้า"
                         subRowItem.push({ "value": item.CatagolyGroupItemName.toString()});//"หมวดหมู่"
                         subRowItem.push({ "value": item.ItemDescription});//"รายละเอียดสินค้า"
                         subRowItem.push({ "value": item.ItemPropertise});//"คุณสมบัติเฉพาะ"
                         let imagedata = itemImage.filter(x => x.ItemRowId == item.RowID);
                         for(let i = 0; i < 5; i++){

                          if (imagedata[0].imageData[i] != undefined){
                            let replacePath = imagedata[0].imageData[i].ItemPicPath.replace("..", window.location.origin);
                            subRowItem.push({ "value": replacePath}); 
                          }else{
                            subRowItem.push({ "value": ""});//"รูปที่ i"
                          }

                         }
                        //  subRowItem.push({ "value": ""});//"รูปที่ 1"
                        //  subRowItem.push({ "value": ""});//"รูปที่ 2"
                        //  subRowItem.push({ "value": ""});//"รูปที่ 3"
                        //  subRowItem.push({ "value": ""});//"รูปที่ 4"
                        //  subRowItem.push({ "value": ""});//"รูปที่ 5"
                         subRowItem.push({ "value": item.ItemPrice.toString()});//"ราคาสินค้าต่อหน่วย"
                         subRowItem.push({ "value": item.ItemUnit});//"หน่วยนับ"
                         subRowItem.push({ "value": item.Quantity.toString()});//"จำนวนสินค้า"
                         subRowItem.push({ "value": ""});//"Admin ตรวจสอบ"
                         subRowItem.push({ "value": item.Comment});//"ความคิดเห็น"
                         rowItem.push(subRowItem);

                     })
                     _template.data.row = rowItem;
                         break;
              }
              
              _template.data.value = setValue;
  
          })
          
          templateForm.userPrincipalName = userData.Email;
          templateForm.subject = templateForm.subject + " : " + userData.NameTh;
          let returnData = await CreateMemorandum(templateForm);
          console.log(returnData);
          if (returnData != null)
          {
            //update properties to db
            let filterItem = supplierList.filter(x => x.SendToProcess !== true);
            await Promise.all(filterItem.map(async (item) => {
              item.SendToProcess = true;
              returnData = await UpdateSupplierProduct(item);
            })
            ).then(() => {
                Swal.fire({
                  title: "ส่งข้อมูลขอสำเร็จ",
                  //text: returnData.data.documentNo ,
                  icon: "success",
                  confirmButtonText: "ตกลง",
                  allowOutsideClick: false,
                  allowEscapeKey: false
              }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    setTableLoading(false);
                  } 
              })
            })


              

          }

          }
          
          //console.log("after" , templateForm);
      }catch(e){
          console.error("createError", e);
      }

      setTableLoading(false);
      //setIsCardLoading(false);

  }

    const importExcel = async (e: any) => {
      Swal.fire({
        title: "หมายเหตุ",
        //text: returnData.data.documentNo ,
        //icon: "question",
        html: `
        กรณีที่ต้องการเพิ่มข้อมูลสินค้าด้วยการ Import from Excel 
        <span style='color: #c95558'>ทางผู้ค้าจะต้องดำเนินการเพิ่มรูปภาพสินค้าทีละรายการด้วยตนเอง</span> หลัง Import file เสร็จสิ้น 
        (ขนาดไม่เกิน 5 เมกะไบต์)
      `,
        confirmButtonText: "ดำเนินการต่อ",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        confirmButtonColor: "#1890ff",
        cancelButtonColor: "#c95558",
    }).then((result) => {
      if (result.isConfirmed) {
          Swal.fire({
            title: "ยืนยันการเพิ่มสินค้า",
            //text: returnData.data.documentNo ,
            //icon: "question",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ไม่ยืนยัน",
            showCancelButton: true,
            confirmButtonColor: "#1890ff",
            cancelButtonColor: "#c95558",
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              setTableLoading(true);
              const file = e.target.files[0];
              try {
                import("xlsx").then((xlsx) => {
                  const reader = new FileReader();
                  try {
                    reader.onload = async (e: any) => {
                      const wb = xlsx.read(e.target.result, { type: "array" });
                      const wsname = wb.SheetNames[0];
                      const ws = wb.Sheets[wsname];
                      const data = xlsx.utils.sheet_to_json(ws, { header: 1 });
                      const cols: any = data[0];
                      data.shift();
                      let _importedData = data.map((d: any) => {
                        return cols.reduce((obj: any, c: any, i: any) => {
                          obj[c] = d[i];
                          return obj;
                        }, {});
                      });
                      if (_importedData.length !== 0) {
                        let res = null;
                        let importData : ISupplierProductModel[] = [];
                        let noCategory = [];
                        for (let i = 0; i < _importedData.length; i++) {
                          const element = _importedData[i];
                          let catName = element["หมวดหมู่"]
                          var catItem = categoryItem.filter((x) => x.label === catName)[0];
                          if (catItem !== undefined){
                            importData.push({
                              RowID: _importedData[i].RowID,
                              ItemID : _importedData[i]["รหัส"],
                              CatagolyGroupItemID : catItem.value,//_importedData[i]["หมวดหมู่"],
                              Contract : _importedData[i]["เลขที่สัญญาจะซื้อขาย"],
                              SellerID : sellerInfo.SellerID,//userData.EmployeeId,
                              ItemName : _importedData[i]["ชื่อสินค้า"],
                              ItemDescription : "",//_importedData[i].ItemDescription,
                              ItemPropertise : _importedData[i]["คุณสมบัติเฉพาะ"],
                              ItemUnit : _importedData[i]["หน่วยนับ"],
                              //IsActive : _importedData[i].IsActive,
                              //IsApprove : _importedData[i].IsApprove,
                              Brand : _importedData[i]["ยี่ห้อ"],
                              Model : _importedData[i]["รุ่น"],
                              Size : _importedData[i]["ขนาด"],
                              Color : _importedData[i]["สี"],
                              Manufacturer : _importedData[i]["ผู้ผลิต"],
                              ItemPrice : _importedData[i]["ราคา"],
                              Quantity : _importedData[i]["จำนวน"],
                              CreatedBy : userData.EmployeeId.toString(),
                              ModifiedBy : userData.EmployeeId.toString(),
                              EditMode: "NEW",
                              SendToProcess: false
                            })
                          }else{
                            let chcekExist = noCategory.includes(catName);
                            if (!chcekExist)
                              noCategory.push(catName);
                          }
                        }

                        //check no category in db
                        if (noCategory.length > 0){
                          Swal.fire({
                            icon: "error",
                            title: "ข้อมูลไม่ถูกต้อง",
                            //text: "ข้อมูลหมวดหมู่ไม่ตรงกับฐานข้อมูล",
                            html: `
                              ข้อมูลหมวดหมู่ไม่ตรงกับฐานข้อมูล <br />
                              <span style='color: #c95558'>`+ noCategory.toString() + `</span>
                            `,
                            confirmButtonText: "ตกลง",
                            showCancelButton: false,
                            confirmButtonColor: "#1890ff"
                          })
                        }else{
                          res = await ImportProduct(importData)
          
                        if (res?.code === "200") {
                          Swal.fire({
                            title: "เพิ่มสินค้าสำเร็จ",
                            icon: "success",
                            confirmButtonText: "ตกลง",
                            confirmButtonColor: "#1890ff",
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
    
                              fetchReport(categoryItem);
                            } 
                        })
                          
                        }
                        }
    
                        
                        setTableLoading(false);
                      }
                    };
          
                    reader.readAsArrayBuffer(file);
                  } catch (error) {
                    setTableLoading(false);
                  }
                });
              } catch (error) {
                setTableLoading(false);
              }
              e.target.value = null;
              
            } 
        })
      }
    });


    


      
    };

    const handleSubmit = async () => {
      
      if (supplierList === undefined){
        Swal.fire({
          title: "ไม่มีรายการที่จะต้องส่งไปอนุมัติ",
          //text: returnData.data.documentNo ,
          icon: "warning",
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          confirmButtonColor: "#1890ff",
      });
        return;
      }
      let countCheckNoImage = [];
      let itemImage = [];
      let checkImage = await Promise.all(supplierList.map( async (item:any) => {
          let tempImage = await GetSupplierProductImage({ ItemRowId: item.RowID});
          if (tempImage.data == null)
            countCheckNoImage.push(item.RowID)
          else
          {
            itemImage.push({
              ItemRowId: item.RowID,
              imageData: tempImage.data
            })
          }
      }));
      //console.log(itemImage);
      //return ;

      //console.log(countCheckNoImage);
      let filterItem = supplierList.filter(x => x.SendToProcess !== true);
      if (filterItem.length > 0)
      {
        if (countCheckNoImage.length > 0)
          {
            Swal.fire({
                  title: "แนบรูปสินค้าไม่ครบถ้วน",
                  //text: returnData.data.documentNo ,
                  icon: "warning",
                  confirmButtonText: "ตกลง",
                  showCancelButton: false,
                  confirmButtonColor: "#1890ff",
              });
          }else{
              Swal.fire({
                  title: "ยืนยันบันทึกข้อมูลสินค้า",
                  //text: returnData.data.documentNo ,
                  //icon: "question",
                  confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ไม่ยืนยัน",
                  showCancelButton: true,
                  confirmButtonColor: "#1890ff",
                  cancelButtonColor: "#c95558",
              }).then((result) => {
                if (result.isConfirmed) {
                  setTableLoading(true);
                  PrcessObjectJson(itemImage);
                }
              });
          }
      }else{
        Swal.fire({
            title: "รายการทั้งหมดรออนุมัติ/ไม่มีรายการที่จะต้องส่งไปอนุมัติ",
            //text: returnData.data.documentNo ,
            icon: "warning",
            confirmButtonText: "ตกลง",
            showCancelButton: false,
            confirmButtonColor: "#1890ff",
            allowOutsideClick: false,
            allowEscapeKey: false
        });
      }

      
      
      
    }
    const handleSearch = (
      selectedKeys: string[],
      confirm: (param?: FilterConfirmProps) => void,
      dataIndex: DataIndex,
    ) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    };
  
    const handleReset = (clearFilters: () => void) => {
      clearFilters();
      setSearchText('');
    };
    const getColumnSearchProps = (dataIndex: DataIndex, placeholder: string) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
              <Input
                  ref={searchInput}
                  placeholder={`ค้นหา ${placeholder}`}
                  value={`${selectedKeys[0] || ''}`}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                  style={{ marginBottom: 8, display: 'block' }}
              />
              <Space>
                  <Button
                      type="primary"
                      onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                      icon={<SearchOutlined />}
                      size="small"
                      style={{ width: 90 }}
                  >
                      Search
                  </Button>
                  <Button
                      onClick={() => clearFilters && handleReset(clearFilters)}
                      size="small"
                      style={{ width: 90 }}
                  >
                      Reset
                  </Button>
              </Space>
          </div>
      ),
      filterIcon: (filtered: boolean) => (
          <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} rev={undefined} />
      ),
      onFilter: (value, record) => {
          return record[dataIndex] != null && record[dataIndex]
              .toString()
              .toLowerCase()
              .includes((value as string).toLowerCase())
      },
      //onFilterDropdownOpenChange: visible => {
      //    if (visible) {
      //        setTimeout(() => searchInput.current?.select(), 100);
      //    }
      //},
      render: text =>
          searchedColumn === dataIndex ? (
              <Highlighter
                  highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={text ? text.toString() : ''}
              />
          ) : (
              text
          ),
  });

    const columns: ColumnsType<DataType> = [
      {
          title: 'รหัส',
          dataIndex: 'ItemID',
          key: 'ItemID',
          width: "10%",
          ...getColumnSearchProps('ItemID', 'รหัส')
        },
      {
        title: 'ชื่อสินค้า',
        dataIndex: 'ItemName',
        key: 'ItemName',
        width: "15%",
        ...getColumnSearchProps('ItemName', 'ชื่อสินค้า')
      },
      {
          title: 'หมวดหมู่',
          dataIndex: 'CatagolyGroupItemName',
          key: 'CatagolyGroupItemName',
          width: "15%",
          ...getColumnSearchProps('CatagolyGroupItemName', 'หมวดหมู่')
        },
        // {
        //   title: 'ยี่ห้อ',
        //   dataIndex: 'Brand',
        //   key: 'Brand',
        //   width: "10%",
        //   ...getColumnSearchProps('Brand', 'ยี่ห้อ')
        // },
        // {
        //   title: 'รุ่น',
        //   dataIndex: 'Model',
        //   key: 'Model',
        //   width: "10%",
        //   ...getColumnSearchProps('Model', 'รุ่น')
        // },
        // {
        //   title: 'ขนาด',
        //   dataIndex: 'Size',
        //   key: 'Size',
        //   width: "10%",
        //   ...getColumnSearchProps('Brand', 'ขนาด')
        // },
        // {
        //   title: 'สี',
        //   dataIndex: 'Color',
        //   key: 'Color',
        //   width: "10%",
        //   ...getColumnSearchProps('Color', 'สี')
        // },
        
        {
          title: 'รายละเอียดสินค้า',
          dataIndex: 'ItemDescription',
          key: 'ItemDescription',
          width: "10%",
          ...getColumnSearchProps('ItemDescription', 'รายละเอียดสินค้า'),
          // render: (text) => {
          //   return <div dangerouslySetInnerHTML={{ __html: text }}></div>
          // }
        },
        {
          title: 'คุณสมบัติเฉพาะ',
          dataIndex: 'ItemPropertise',
          key: 'ItemPropertise',
          width: "10%",
          ...getColumnSearchProps('ItemPropertise', 'คุณสมบัติเฉพาะ'),
          render: (text) => {
            return text?.length > 500 ? ( 
                <Popover content={<div style={{maxWidth: '400px'}} dangerouslySetInnerHTML={{ __html: text }}></div>} title="คุณสมบัติเฉพาะ" trigger="hover">
                  <Button>แสดงรายละเอียด</Button> 
                </Popover>

            ) : (

              <div dangerouslySetInnerHTML={{ __html: text }}></div>
            )
          }
        },
        {
          title: 'ผู้ผลิต',
          dataIndex: 'Manufacturer',
          key: 'Manufacturer',
          width: "10%",
          ...getColumnSearchProps('Manufacturer', 'ผู้ผลิต')
        },
        {
          title: 'ราคา',
          dataIndex: 'ItemPrice',
          key: 'ItemPrice',
          width: "10%",
          ...getColumnSearchProps('ItemPrice', 'ราคา'),
          render: (text) => {
            var checkData = text != null ? parseFloat(text).toFixed(2) : 0.00;
            var textData = checkData === "0.00" ? "-" : checkData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return <div style={{textAlign: "right"}}>{textData}</div>;
        }
        },
        {
          title: 'จำนวน',
          dataIndex: 'Quantity',
          key: 'Quantity',
          width: "10%",
          ...getColumnSearchProps('Quantity', 'จำนวน')
        },
        {
          title: 'หน่วยนับ',
          dataIndex: 'ItemUnit',
          key: 'ItemUnit',
          width: "10%",
          ...getColumnSearchProps('ItemUnit', 'หน่วยนับ')
        },
        {
          title: 'เลขที่สัญญา',
          dataIndex: 'Contract',
          key: 'Contract',
          width: "10%",
          ...getColumnSearchProps('Contract', 'เลขที่สัญญา')
        },
    
      // {
      //     title: '#',
      //     key: 'action',
      //     width: "12%",
      //     render: (_, record) => (
      //         <Space>
      //              <Button
      //         type="primary"
      //         onClick={() => {
      //             let checkYear = dayjs(record.BudgetYear + '-01-01').locale(th).add(-543, "year")//.isValid();
      //             //dayjs(monthParam + "-01").locale(th).format('MMMM BBBB');
      //             let itemEdit:Values = {
      //                 BudgetID : record.BudgetID,
      //                 DepartmentCode: record.DepartmentCode,
      //                 DivisionCode: record.DivisionCode,
      //                 SectionCode: record.SectionCode,
      //                 IsUnLimit: record.IsUnLimit,
      //                 TotalBudget: record.TotalBudget,
      //                 CurrentBudget: record.CurrentBudget,
      //                 BudgetYear: checkYear,//record.BudgetYear != "" ?? dayjs(record.BudgetYear + ""),
      //                 IsActive: record.IsActive,
      //                 CreatedBy: userData.EmployeeId.toString(),
      //                 ModifiedBy: userData.EmployeeId.toString()
      //             }
      //             //setDataSourceDetail(itemEdit);
      //             form.setFieldsValue(itemEdit);
      //             setOpenPopupEdit(true);
                
      //         }}
      //     >
      //         แก้ไขข้อมูล
      //     </Button>
      //     <Button
      //         type="primary"
      //         onClick={async () => {
      //             await onDeleteItemClick(record);
      //         }}
      //     >
      //         ลบข้อมูล
      //     </Button>
      //         </Space>
             
          
      //     ),
      //   },
    ];

    const beforeUpload = (file: RcFile) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('สามารถอัพโหลดได้เฉพาะไฟล์ JPG/PNG เท่านั้น!');
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error('รูปภาพจะต้องมีขนาดน้อยกว่า 5MB!');
      }
      let returnCheck = isJpgOrPng && isLt5M;
      if (returnCheck)
      {
        //setFileList([...fileList, file]);
      }
      return returnCheck || Upload.LIST_IGNORE;
    };
    
    if (isLoad) {
      return <></>;
    } else {
      return (
        <Layout>
          {/* <Sider width={250} className={styles.side_bars_sup_list}>
            <div className={styles.filter_func}>
              <FilterOutlined rev={undefined} />
              สินค้าบน E-Catalog
            </div>
          </Sider>
          
          <Sider width={300} className="side-bars">
          {sidebar} 
          </Sider>*/}
          <Layout className={styles.layout_content}>
            <Content className={styles.contents}>
              <div className={styles.content_header}>
                <p className={`${styles.p_tag} ${styles.header}`}>ข้อมูลทั่วไป</p>
                <div className={styles.header_button}>
                <Button className={styles.button_add} size="large" onClick={() => {
                  setItemOnModal(undefined);
                  setContentEditor((prevState: any) => ({
                    ...prevState,
                    value: "",
                  }));
                  setFileList([]);
                  //form.resetFields();
                  
                  setOpenModal(true);

                }}>
                  เพิ่มสินค้าด้วยตัวเอง
                </Button>
               

                <Button className={styles.button_import} size="large" onClick={() => inputFile.current.click() }>
                  Import From Excel
                </Button>
                <>
                    <input
                      type="file"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      onChange={importExcel}
                      style={{ display: "none" }}
                      id="file"
                      ref={inputFile}
                    />

                  </>
              
                <Button className={styles.button_export} size="large" onClick={async () => {
                      await exportExcel([],
                        "new_product",
                        tableData,
                        setExportLoading
                      );
                    }}>
                  Export From Excel
                </Button>
                </div>
                
              </div>
              {/* <DynamicTableRedCross
                checkBox={false}
                tableName="ECatalog"
                dataSource={tableData}
                customColumns={undefined} //{supplierColumns}
                setItemsCount={setItemsCount}
                actionBodyTemplate={actionBodyTemplate}
                paginationOption={paginationOption}
                canEdit={true}//{isAdmin || canEdit}
                canExport={false}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows} dataKey={""}   
                loading={tableLoading}
                           /> */}
 <Table rowKey={record => record.RowID}
                    className={'main-table-product'}
                    bordered
                    dataSource={supplierList}
                    columns={columns} /*scroll={{ x: 4000, y: 700 }}*/ loading={tableLoading}
                    pagination={{ position: ['bottomCenter'] }}
                    rowSelection={{
                      type: "checkbox",
                      renderCell: (value, record, index, originNode) => {
                        return (
                          <>{actionBodyTemplate(record)}</>
                        );
                      },
                    }}
                />
                           <div style={{textAlign:"center", marginTop: "15px"}}> 
                           <Button key="modalback" className={styles.btn_submit} size="large" disabled={tableLoading} onClick={() => handleSubmit() }>
                           บันทึกรายการ
              </Button>
                           </div>



                          
            </Content>
          </Layout>
          <Modal
            title="ข้อมูลสินค้าที่ต้องการเพิ่ม"
            className={styles.modal_product }
            centered
            closable={false}
            maskClosable={false}
            visible={openModal}
            // onOk={() => {
              
            // } }
            //onCancel={() => setOpenModal(false)}
            //confirmLoading={confirmLoading}
            width={1000}
            footer={[
              <Button key="modalback" className={styles.btn_not_accept} onClick={() => setOpenModal(false) } disabled={confirmLoading}>
                ยกเลิก
              </Button>,
              <Button key="modalsubmit" className={styles.btn_accept} type="primary" loading={confirmLoading} hidden={form.getFieldValue("SendToProcess")} onClick={() => {
                form.validateFields()
              .then(async values => {
                  //form.resetFields();
                  //onCreate(values);
                  await handleSaveModal(values);
              })
              .catch(info => {
                  console.log('Validate Failed:', info);
              });
              }}>
                บันทึก
              </Button>
              
              
            ]}
      >
            <Form form={form} name="control-hooks" initialValues={itemOnModal}>
                <Form.Item hidden name="RowID"></Form.Item>
                <Form.Item hidden={!form.getFieldValue("SendToProcess")}>
                  <div className="" style={{fontWeight: "bold", fontSize: "16px", borderBottom: "1px solid #dbdbdb", marginBottom: "8px", color:"#ed9538" }}>
                    รายการนี้อยู่ระหว่างการดำเนินการอนุมัติ
                  </div>
                </Form.Item>

                <Form.Item label="รหัส" name="ItemID" rules={[{ required: true, message: 'กรอกรหัสสินค้า' }]}>
                  <Input maxLength={10}></Input>
                </Form.Item>
                <Form.Item label="ชื่อสินค้า" name="ItemName" rules={[{ required: true, message: 'กรอกชื่อสินค้า' }]}>
                  <Input></Input>
                </Form.Item>
                <Form.Item label="หมวดหมู่" name="CatagolyGroupItemID" rules={[{ required: true, message: 'กรอกหมวดหมู่' }]}>
                <Select
                    showSearch
                    //placeholder="Search to Select"
                    optionFilterProp="children"
                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                    options={categoryItem}
                  />
                </Form.Item>
                {/* <Form.Item label="ยี่ห้อ" name="Brand">
                  <Input></Input>
                </Form.Item>
                <Form.Item label="ชื่อรุ่น" name="Model">
                  <Input></Input>
                </Form.Item>
                <Form.Item label="ขนาด" name="Size">
                  <Input></Input>
                </Form.Item>
                <Form.Item label="สี" name="Color">
                  <Input></Input>
                </Form.Item> */}
                <Form.Item label="รายละเอียดสินค้า" name="ItemDescription" style={{marginBottom: "8px"}}>
                  <TextArea rows={4}  maxLength={1000} />
                </Form.Item>
                <Form.Item label="คุณสมบัติเฉพาะ" style={{marginBottom: "8px"}}>
                <Editor
              onInit={() => {
                //setLoading(false);
              }}
              init={{
                // selector: "textarea#file-picker",
                statusbar: false,
                paste_data_images: false,
                menubar: false,
                content_css: false,
                // auto_focus: "elm1",
                height: "20vh",
                fullscreen_native: false,
                remove_script_host: false,
                relative_urls: false,
                image_title: false,
                automatic_uploads: false,
                image_sourcetab: false,
                image_advtab: false,
                plugins: [
                  "image code",
                  "advlist autolink lists image charmap print preview hr anchor pagebreak",
                  "searchreplace wordcount  code fullscreen",
                  "insertdatetime media nonbreaking save table contextmenu directionality",
                  "emoticons template paste textcolor colorpicker textpattern imagetools  image",
                  "link",
                ],
                toolbar1:
                  "styleselect | fontsizeselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist",
                  //"insertfile undo redo | styleselect | fontselect | fontsizeselect | bold italic underline |  forecolor backcolor | alignleft aligncenter alignright alignjustify | searchreplace | bullist numlist outdent indent | pagebreak | link table | image | fullscreen",
                fontsize_formats:
                  "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 36pt",
              }}
              value={contentEditor?.value}
              
              onEditorChange={handleEditorChange}
            />
                </Form.Item>
                <Form.Item label="แนบรูปภาพสินค้า" required extra="อัพโหลดได้เฉพาะไฟล์ JPG/PNG และมีขนาดไม่เกิน 5MB">
                <Upload key={"upload-product"}
                  className="ecat-pic-upload"
                  listType="picture-card"
                  fileList={fileList}
                  onChange={handleChange}
                  maxCount={5}
                  multiple
                  // beforeUpload={(file) => {
                  //   setFileList([...fileList, file]);
              
                  //   return false;
                  // }}
                  beforeUpload={beforeUpload}
                  onRemove={(file) => 
                    {
                      const index = fileList.indexOf(file);
                      const newFileList = fileList.slice();
                      newFileList.splice(index, 1);
                      setFileList(newFileList);

                      setFileListRemove([...fileListRemove, file]);
                    }
                  } 
                >
                  {fileList.length >= 5 ? null : uploadButton}
                </Upload>
                </Form.Item>
                <Form.Item label="ราคาสินค้าต่อหน่วย" name="ItemPrice"  rules={[{ required: true, message: 'กรอกราคาสินค้าต่อหน่วย' }]}>
                  <Input type="number" ></Input>
                </Form.Item>
                <Form.Item label="จำนวนสินค้า" required name="Quantity" rules={[{ required: true, message: 'กรอกจำนวนสินค้า' }]}>
                  <Input type="number"></Input>
                </Form.Item>
                <Form.Item label="หน่วยนับ" required name="ItemUnit" rules={[{ required: true, message: 'กรอกหน่วยนับ' }]}>
                  <Input></Input>
                </Form.Item>
                <Form.Item label="เลขที่สัญญาจะซื้อขาย" required name="Contract" rules={[{ required: true, message: 'กรอกเลขที่สัญญาจะซื้อขาย' }]}>
                  <Input></Input>
                </Form.Item>
            </Form>
        </Modal>
        </Layout>

        
      );
    }
  };
  
  export default SupplierListProductScreen;


